var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideSuggestion),expression:"!hideSuggestion"}],staticClass:"list-group",attrs:{"no-body":""}},[_c('div',{staticClass:"list-group-item d-flex",on:{"click":_vm.suggestionClicked}},[_c('i',{staticClass:"ion-android-pin mr-2"}),_c('p',[_vm._v(_vm._s(_vm.suggestion.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }